module.exports = __webpack_public_path__ + "static/livechat1-8423cb50f668b5c698b555a5fee4e44d.png";